import L from 'leaflet';
import "./homeDenseIcon.css";
/**
 * Compact static home pin (CreateAreaPage / register map preview).
 * CSS is loaded as a side effect of this module.
 */

export function createHomeDenseIcon() {
  return L.divIcon({
    className: 'home-dense-marker',
    html: "\n          <div class=\"home-dense-pin\">\n            <div class=\"home-dense-pin__head\">\n              <svg viewBox=\"0 0 24 24\" class=\"home-dense-pin__icon\" aria-hidden=\"true\">\n                <path d=\"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z\"/>\n              </svg>\n            </div>\n            <div class=\"home-dense-pin__tip\"></div>\n          </div>\n        ",
    iconSize: L.point(28, 36),
    iconAnchor: L.point(14, 34)
  });
}